import axios from 'axios';

export const state = () => ({
  categories: [],
  currentCategory: {}
})

export const mutations = {
  setSmiCategories(state, categories) {
    state.categories = categories
  },
  setCurrentCategory(state, category) {
    state.currentCategory = category
  }
}

export const actions = {
  async getSmiCategories({ commit }) {
    try {
      await axios.get('/api/my-smi-categories').then(res => {
        commit('setSmiCategories', res.data)
      })
    } catch (e) {
      console.log(e)
    }
  },
  // eslint-disable-next-line no-unused-vars
  async fetchCurrentCategory({ commit }, id) {
    try {
      await axios
        .get(`/api/my-smi-categories/${id}`)
        .then(res => commit('setCurrentCategory', res.data))
    } catch (e) {
      console.log(e)
    }
  }
}

export const getters = {
  getSmiCategories: state => state.categories,
  getCurrentCategory: state => state.currentCategory
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};